import { Box, Spinner } from '@chakra-ui/react'

export default function LoadingComponent() {
  return (
    <Box display='flex' justifyContent='center' alignItems='center' height='100vh' children={<Spinner size='xl' />} />
  )
}
